







import { Component, Vue, Model, Emit } from 'vue-property-decorator';
import SearchPaginationTable from '@/components/search-pagination-table.vue';
import AddRule from './add-rule.vue';
import EditRule from './edit-rule.vue';
import moment from 'moment';
import { post } from '@/unite/api';
@Component({
  components: { SearchPaginationTable, AddRule, EditRule }
})
export default class RunningwaterDetails extends Vue {
  created() {
    // console.log(this.api.get('/admin/apply/list', this.pageData.info))
  }
  optionTitle: string = '';
  isAdd: boolean = false;
  isEdit: boolean = false;
  modifyForm: any;
  rules: any[] = [];
  sendData: any;
  pageData: any = {
    url: '/back/v1/sys/rule/list',
    isSearch: false, // 是否需要搜索框
    isPagination: true, // 是否后端分页
    isBtn: true, // 是否需要头部操作按钮
    info: {
      name: '',
      page_num: 10,
      page_index: 1
    }, // 传后端数据
    searchData: [
      {
        type: 'input', // text框
        model: 'name', // 字段
        tip: '规则',
        placeholder: '请输入要查询的规则'
      }
    ],
    btnData: [
      {
        name: '刷新列表',
        methods: 'refesh',
        type: 'success',
        loading: false
      },
      {
        name: '添加规则',
        methods: 'add',
        type: 'success',
        loading: false
      },
      {
        name: '导出规则',
        methods: 'downAll',
        type: 'downAll',
        loading: false
      }
    ],
    tableData: {
      stripe: true,
      border: true,
      expandShow: false,
      optionShow: true,
      header: [
        // {
        //   prop: 'id',
        //   label: 'ID'
        // },
        {
          prop: 'unified_number',
          label: '电话号码'
        },
        {
          prop: 'unified_name',
          label: '银行'
        },
        {
          prop: 'unified_type',
          label: '类型'
        },
        {
          prop: 'unified_code',
          label: 'Code',
          type: 'pv'
        },
        {
          prop: 'action_code',
          label: 'action_code',
          // type: 'sv'
        },
        {
          prop: 'action_desc',
          label: '描述'
        },
        {
          prop: 'action_rule',
          label: '匹配规则'
        },
        {
          prop: 'code_rule',
          label: '解析规则'
        }
      ],
      expand: [],
      optionWidth: 150,
      option: [
        {
          name: '修改规则',
          methods: 'modify',
          type: 'success',
          role: function(row: any) {
            return 1;
          }
        }
      ]
    } // table
  };
  private handleClick(methods: string, row: any) {
    this.sendData = row
    if (methods === 'modify') {
      this.isEdit = true;
    }
  }
  private btnClick(methods: string) {
    if (methods === 'add') {
      this.isAdd = true;
    }
  }
  // 刷新列表
  refesh(bool: boolean) {
    if (bool) {
      // @ts-ignore
      this.$refs.table.getData();
    }
    this.isAdd = false;
    this.isEdit = false;
  }
}
